export const getMimeType = (extension: string) => {
  switch (`.${extension.toLowerCase()}`) {
    case '.jpg':
    case '.jpeg':
      return 'image/jpeg'
    case '.png':
      return 'image/png'
    case '.gif':
      return 'image/gif'
    case '.webp':
      return 'image/webp'
    case '.svg':
      return 'image/svg+xml'
    case '.mp4':
      return 'video/mp4'
    case '.avi':
      return 'video/x-msvideo'
    case '.mov':
      return 'video/quicktime'
    case '.mkv':
      return 'video/x-matroska'
    case '.pdf':
      return 'application/pdf'
    default:
      return 'application/octet-stream' // Fallback for unknown types
  }
}

export const getExtensionFromMimeType = (mimeType: string) => {
  switch (mimeType.toLowerCase()) {
    case 'image/jpeg':
      return 'jpg'
    case 'image/png':
      return 'png'
    case 'image/gif':
      return 'gif'
    case 'image/webp':
      return 'webp'
    case 'image/svg+xml':
      return 'svg'
    case 'video/mp4':
      return 'mp4'
    case 'video/x-msvideo':
      return 'avi'
    case 'video/quicktime':
      return 'mov'
    case 'video/x-matroska':
      return 'mkv'
    case 'application/pdf':
      return 'pdf'
    default:
      return ''
  }
}
